import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useAppSelector } from '../../app/hooks'
import { selectAuth } from '../../features/auth/authSlice'

export default function ProtectedRoutes() {
    const { user } = useAppSelector(selectAuth)
    return user ? <Outlet /> : <Navigate to="/auth/login" />
}
